import template from './service-action-priorities.html';
import controller from './service-action-priorities.controller';

let serviceActionPrioritiesComponent = {
    bindings: {},
    template,
    controller
};

export default serviceActionPrioritiesComponent;



// WEBPACK FOOTER //
// ./client/app/components/service_settings/service-action-priorities/service-action-priorities.component.js